var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHazeFill = function SvgHazeFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#haze-fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.055 8.667a4 4 0 1 1 7.89 0h-7.89ZM1.333 10H8v1.333H1.333V10Zm8 0h5.334v1.333H9.333V10Zm1.334 2.667h2.666V14h-2.666v-1.333Zm-8 0h6.666V14H2.667v-1.333Zm4.666-12h1.334v2H7.333v-2Zm-4.99 2.62.943-.944L4.7 3.757l-.943.943-1.414-1.413Zm10.37-.944.943.943L12.242 4.7l-.943-.943 1.414-1.414Zm2.62 4.99v1.334h-2V7.333h2Zm-12.666 0v1.334h-2V7.333h2Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "haze-fill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgHazeFill;